import React, { useState } from 'react';
import styles from "./expandable.module.css";
import { Icon } from '@iconify/react';

const ExpandableSystemStats = ({id, title, children}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    const togglePanel = () => {
        setIsExpanded(prevState => !prevState);
    };
    
    return (
        <div className={`${styles.expandablePanel} border border-[#EAEAEA] shadow-sm rounded-lg items-center`}>
            <div className={`${styles.panelHeader}`} onClick={togglePanel}>
                <h4 className="text-[#036F36] font-medium text-sm sm:text-base">
                    {title}
                </h4>
                <Icon 
                    icon={isExpanded ? "heroicons:chevron-up" : "heroicons:chevron-down"} 
                    className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" 
                />
            </div>
            <div className={`${styles.panelContent} ${isExpanded ? `${styles.expanded}` : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default ExpandableSystemStats;